import { PlatformType } from '@/types/common.types';

export const LINKED_VIEW_PATH_MAP: Record<PlatformType, Record<string, string>> = {
  application: {
    transactionTrend: '/application/performance-analysis/transaction-trend',
  },
  infrastructure: {},
  messageQueue: {},
  kubernetes: {},
  webServer: {},
  database: {},
  cloud: {},
};
